import { render, staticRenderFns } from "./QteVsEffChart.vue?vue&type=template&id=04513415&"
import script from "./QteVsEffChart.vue?vue&type=script&lang=js&"
export * from "./QteVsEffChart.vue?vue&type=script&lang=js&"
import style0 from "./QteVsEffChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports